import { useContext } from 'react';
import { Button, makeStyles } from '@material-ui/core';
import MyDataSpacesViewContext from '../../context/MyDataSpacesViewContext';
import { UserProfileContext } from '../../../../UserProfileContext';
import { trackEvent } from '../../../../utils/eventTracking';
import CreateEditDataSpaceContext from '../../context/CreateEditDataSpaceContext';

const BackButton = () => {
	const createEditDataSpaceContext = useContext(CreateEditDataSpaceContext);
	// User Profile Data
	const userProfile = useContext(UserProfileContext)[0];

	const myDataSpacesViewContext = useContext(MyDataSpacesViewContext);

	const returnToDataDirectory = () => {
		myDataSpacesViewContext.changeViewHandler('configureNewDataSpace');

		// Event tracking for successfully adding a datasource to new dataspace.
		const eventName =
			createEditDataSpaceContext.createEditDataSpaceMode === 'edit'
				? 'Returned to Configure Dataspace Page in Edit Dataspace Form.'
				: 'Returned to Configure Dataspace Page in New Dataspace Form.';
		trackEvent({
			userDetails: { userId: userProfile._id, email: userProfile.email },
			eventDetails: { types: ["KissMetrics", 'Segment', 'Encharge', 'AppInsights'], eventName },
		});
	};

	return (
		<Button variant="contained" margin="normal" color="primary" onClick={returnToDataDirectory}>
			Back
		</Button>
	);
};

export default BackButton;
